module.exports = __webpack_public_path__ + "img/24.1051c925.png";